import i18next, { type i18n } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export type I18nConfig = {
  /** 検出した言語が supportedLanguages に無いときに使う言語。 */
  defaultLanguage: string;
  supportedLanguages: readonly string[];
  /** 選択言語を保存する localStorage のキー。 */
  storageKey: string;
};

/**
 * i18next を初期化してインスタンスを返す。各アプリの `app/provider.tsx` のモジュールスコープで
 * 1 度だけ呼ぶ (I18nProvider の外側に置く AppErrorBoundary もこのインスタンスを直接使うため、
 * render より前に初期化しておく)。
 */
export function createI18n({ defaultLanguage, supportedLanguages, storageKey }: I18nConfig): i18n {
  void i18next
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: defaultLanguage,
      supportedLngs: [...supportedLanguages],
      detection: {
        order: ["localStorage", "navigator"],
        lookupLocalStorage: storageKey,
        caches: ["localStorage"],
      },
      backend: {
        loadPath: "/locales/{{lng}}/translation.json",
      },
      interpolation: { escapeValue: false },
      // I18nProvider 内で useTranslation の ready を待つ運用のため、
      // Suspense でアプリ全体が中断されないよう無効化する
      react: { useSuspense: false },
    });
  return i18next;
}
